import { CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {
	EnvironmentProviders,
	ModuleWithProviders,
	NgModule,
	Provider,
	Type,
	inject,
	provideAppInitializer
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FileOpener } from "@awesome-cordova-plugins/file-opener/ngx";
import { FileTransfer } from "@awesome-cordova-plugins/file-transfer/ngx";
import { Network } from "@awesome-cordova-plugins/network/ngx";
import { IonicModule } from "@ionic/angular";
import { ComponentsModule } from "./components/components.module";
import { SharedComponentsModule } from "./components/sharedComponents.module";
import { FilesystemModule } from "./modules/filesystem/filesystem.module";
import { ReminderAlarmsService } from "./modules/reminder-alarms/services/reminder-alarms.service";
import { DevicesModule } from "./modules/security/devices/devices.module";
import { StoreModule } from "./modules/store/store.module";
import { TabsModule } from "./modules/tabs/tabs.module";
import { TransferModule } from "./modules/transfert/transfer.module";
import { UIService } from "./modules/utils/services/ui.service";
import { VersionsModule } from "./modules/versions/versions.module";
import { ZipModule } from "./modules/zip/zip.module";
import { PipeModule } from "./pipes/pipes.module";
import { InjectorService } from "./services/injector.service";
import { OrchestratorService } from "./services/orchestrator.service";
import { ServiceModule } from "./services/services.module";

// Permet d'initialiser les services en paramètres au démarrage de l'app.
function initializeOsappFactory( // Injections ordonnées par priorité pour éviter des couacs.
	psvcInjector: InjectorService,
	psvcOrchestrator: OrchestratorService,
	psvcUI: UIService,
	psvcReminders: ReminderAlarmsService
): () => void {
	return () => {
		//* Placer ici les initialisations globales à faire au démarrage de l'app.
		psvcOrchestrator.init();
		psvcReminders.initAsync();
	};
}

const importModules: (Type<any> | ModuleWithProviders<any>)[] = [
	IonicModule,
	CommonModule,
	FormsModule,
	ReactiveFormsModule,
	ServiceModule,
	PipeModule,
	ComponentsModule,
	TabsModule,
	ZipModule,
	VersionsModule,
	DevicesModule,
	StoreModule,
	FilesystemModule,
	TransferModule
];
const exportModules: Type<any>[] = [ComponentsModule, ServiceModule, PipeModule, SharedComponentsModule];
const providers: (Provider | EnvironmentProviders)[] = [
	Network,
	FileOpener,
	FileTransfer,
	provideHttpClient(withInterceptorsFromDi()),
	provideAppInitializer(() => {
		const initializerFn = initializeOsappFactory(
			inject(InjectorService),
			inject(OrchestratorService),
			inject(UIService),
			inject(ReminderAlarmsService)
		);
		return initializerFn();
	})
];

@NgModule({
	imports: importModules,
	exports: exportModules,
	providers: providers
})
export class OsappModule {}
